import React from 'react';

import { Dropdown } from 'primereact/dropdown';

const DropDownField = ({ field, form, onChange, ...restProps }) => {
  return <Dropdown {...field} {...restProps} />;
};

export default React.memo(DropDownField);
